import { useState } from 'react';
import { Box, Card, CardContent, Stack, Typography } from '@mui/material';
import { useQuery } from '@tanstack/react-query';
import buildFilterString from '../../helpers/buildFilterString';
import styles from './styles.module.css';
import parseFilterStringToDateRange from 'src/views/dashboards/helpers/parseFilterStringToDateRange';
import CostComparison from './CostComparison';
import { SlashForward } from 'mdi-material-ui';
import { calculateAverageValue } from './helpers';
import { Products, useGetProductLevel } from 'src/@core/utils/getProductLevel';
import { getSalesOrders } from 'src/services/salesorder';

const AverageCostPerPalletSpace = ({ dashboardDateStrings = [[''], ['']], orderByValue = '' }) => {
  const [totalSpaces, setTotalSpaces] = useState(0);
  const [totalValue, setTotalValue] = useState(0);
  const prod = useGetProductLevel();

  const title = prod === Products.MyPortal ? ' Average Cost Per Pallet Space' : 'Average Revenue Per Pallet Space';

  useQuery({
    queryKey: [
      'averageCostPerPalletSpace',
      buildFilterString(orderByValue, dashboardDateStrings),
      orderByValue,
      dashboardDateStrings
    ],
    queryFn: async () => {
      const res = await getSalesOrders({ filter: buildFilterString(orderByValue, dashboardDateStrings) });

      return res.data;
    },
    onSuccess: (data: any[]) => {
      setTotalSpaces(data.reduce((acc, curr) => acc + curr.totalSpaces, 0));
      setTotalValue(data.reduce((acc, curr) => acc + Number.parseFloat(curr.price), 0));
    }
  });

  const { selectedRange } = parseFilterStringToDateRange(dashboardDateStrings.join(' '));

  return (
    <Card className={styles.card} sx={{ width: '100%', height: '100%' }}>
      <CardContent sx={{ height: '100%' }}>
        <Stack direction="column" sx={{ height: '100%' }}>
          <Box className={styles.titleContainer}>
            <Typography
              className={styles.title}
              sx={{
                textAlign: 'left',
                fontSize: '1.571rem',
                fontWeight: '600'
              }}>
              {title}
            </Typography>
          </Box>
          <Stack
            className={styles.valuesOuterContainer}
            alignItems="stretch"
            justifyContent="space-between"
            sx={{ flex: '1', paddingInline: '35px' }}>
            <Box className={styles.valueContainer}>
              <Typography className={styles.value}>{`£${calculateAverageValue(totalValue, totalSpaces)}`}</Typography>
            </Box>

            <Stack direction="row" alignItems="center">
              <Box sx={{ display: 'flex', alignItems: 'flex-end' }}>
                <SlashForward sx={{ fontSize: '4.286rem' }} />
              </Box>
              <Stack
                direction="column"
                justifyContent="center"
                alignItems="center"
                sx={{ transform: 'translateY(-10px)' }}>
                <Typography
                  sx={{ fontSize: '0.857rem', lineHeight: '1', textTransform: 'uppercase', textAlign: 'justify' }}>
                  Total Spaces
                </Typography>
                <Typography sx={{ fontSize: '4rem', lineHeight: '1' }}>{totalSpaces}</Typography>
              </Stack>
            </Stack>
          </Stack>

          <CostComparison
            selectedRange={selectedRange}
            orderByValue={orderByValue}
            initialAverage={calculateAverageValue(totalValue, totalSpaces)}
          />
        </Stack>
      </CardContent>
    </Card>
  );
};

export default AverageCostPerPalletSpace;
